//时间转换
export function DataConvert(d) {
    d = new Date(d)
    var year = d.getFullYear();
    var month = d.getMonth() + 1;
    var day = d.getDate();
    var hours = d.getHours();
    var min = d.getMinutes();
    var seconds = d.getSeconds();
    if (month < 10) month = '0' + month;
    if (day < 10) day = '0' + day;
    if (hours < 0) hours = '0' + hours;
    if (min < 10) min = '0' + min;
    if (seconds < 10) seconds = '0' + seconds;
    return year + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + seconds;
}

// 表格更改过滤
export function changeFilteredInfo(searchArr) {

    let filter = {}
    searchArr.map(item => {
        if (['至', '~', '——'].some(range => item.value.includes(range))) {
            let splitString = item.value.includes('至') ? '至' : item.value.includes('~') ? '~' : '——'
            filter[item.key] = item.value.split(splitString).map(item=>typeof item==='string'?item.trim():item)
        } else {
            filter[item.key] = [item.value]
        }
    })
    return filter
}
export function getTableCol() {

    return [
        {
            title: '分析类型',
            dataIndex: 'sampleId',
            key: 'sampleId1',
            children:[
                {
                    title: '分析类型要求123rttt',
                    dataIndex: 'sampleId',
                    key: 'sampleId2',
                    sorter: true,
                    questionTitle:'titleName',
                    slots: {
                        title:'titleName',
                        questionTitle: 'titleName',
                        questionNote: 'wordConvert(this.fileName,titleName,groupSampleName)',
                    },
                    isOpenNewSearch:true,
                    sortDirections: ["ascend", "descend", "ascend"],
                    scopedSlots: {
                        filterDropdown: 'filterDropdownMailType',
                        filterIcon: 'filterIcon',
                        customRender: 'ellipsisAndLook'
                        // filtered: true,
                    },
                },
                {
                    title: '分析类型要求123rttt',
                    dataIndex: 'sampleId',
                    key: 'sampleId3',
                    sorter: true,
                    questionTitle:'titleName',
                    slots: {
                        title:'titleName',
                        questionTitle: 'titleName',
                        questionNote: 'wordConvert(this.fileName,titleName,groupSampleName)',
                    },
                    isOpenNewSearch:true,
                    sortDirections: ["ascend", "descend", "ascend"],
                    scopedSlots: {
                        filterDropdown: 'filterDropdownNum',
                        filterIcon: 'filterIcon',
                        customRender:'tttt'
                        // filtered: true,
                    },
                },
            ]
            // sorter: true,
            // questionTitle:'titleName',
            // slots: {
            //     title:'titleName',
            //     questionTitle: 'titleName',
            //     questionNote: 'wordConvert(this.fileName,titleName,groupSampleName)',
            // },
            // isOpenNewSearch:true,
            // sortDirections: ["ascend", "descend", "ascend"],
            // scopedSlots: {
            //     filterDropdown: 'filterDropdown',
            //     filterIcon: 'filterIcon',
            //     // filtered: true,
            // },
        },
        {
            title: '分析类型要求123rttt',
            dataIndex: 'sampleId',
            key: 'sampleId',
            sorter: true,
            questionTitle:'titleName',
            slots: {
                title:'titleName',
                questionTitle: 'titleName',
                questionNote: 'wordConvert(this.fileName,titleName,groupSampleName)',
            },
            isOpenNewSearch:true,
            sortDirections: ["ascend", "descend", "ascend"],
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                // filtered: true,
            },
        },
        {
            title: '客户姓名1',
            dataIndex: 'customerName',
            key: 'customerName',
            sorter: true,
            sortDirections: ["ascend", "descend", "ascend"],
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'customerName'
            },
            // filteredValue: filteredInfo.customerName || [],
        },
        {
            title: '客户姓名11',
            dataIndex: 'customerName1',
            key: 'customerName1',
            sorter: true,
            sortDirections: ["ascend", "descend", "ascend"],
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'customerName1'
            },
            // filteredValue: filteredInfo.customerName || [],
        },
    ]
}
export function newContractRule(value){
    const rule=/^(BZ)(?<del>[D|F]?)(\d{14})$/
    if(value){
        if(rule.test(value)){
            return true
        }
    }
    return false
}
